interface PreFillFormProps {
	setValue: Function
}
const PreFillForm: React.FC<PreFillFormProps> = ({ setValue }) => {
	return (
		<>
			{process.env.NODE_ENV === "development" && (
				<span
					className="btn btn-green"
					onClick={() => {
						setValue("firstName", "firstname")
						setValue("lastName", "lastname")
						setValue("email", "ff@fake.de")
						setValue("birthday", "1970-01-01")
						setValue("street", "Dorfstraße")
						setValue("houseNr", "12")
						setValue("zip", "24558")
						setValue("city", "Teststadt")
						setValue("optInTerms", true)
						setValue("optInPrivacy", true)
					}}
				>
					+++ fill with testdata ++++
				</span>
			)}
		</>
	)
}

export default PreFillForm
